import './NotFound.scss';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import HomeNav from '../HomeNav';
import RoundedButton from '../../../Components/RoundedButton/RoundedButton';

export default function NotFound() {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className="xpektor-home">
      <div className="not-found">
        <HomeNav />
        <div className="not-found-content">
          <h1 className="title">{t('not-found-page.header')}</h1>
          <RoundedButton
            text={t('shared.back-to-start-page')}
            fillCyan
            onClick={() => history.push('/')}
          />
          <h1 className="not-found-sign">404</h1>
        </div>
      </div>
    </div>
  );
}
